import React from 'react'
import { Nav } from 'react-bootstrap'
import { NavLink , useLocation } from 'react-router-dom'
import './sidebar.scss'
const Sidebar = () => {
  const location = useLocation();
  return (
    <>
      <div className='sidebar-wrapper'>
        <div className='content-main'>
          <div className='about-nav-title'>
            <h2>About Sentry</h2>
          </div>
          <Nav className="navLinks">
            <NavLink to="/aboutus" className={location.pathname === '/aboutus' ? 'active' : ''}>
              <span>About us</span>
            </NavLink>
            <NavLink to="/aboutus/annualreport" className={location.pathname === '/aboutus/annualreport' ? 'active' : ''}>
              <span>Annual report</span>
            </NavLink>
            <NavLink to="/aboutus/community" className={location.pathname === '/aboutus/community' ? 'active' : ''}>
              <span>Community engagement</span>
            </NavLink>
            <NavLink to="/aboutus/ourhistory" className={location.pathname === '/aboutus/ourhistory' ? 'active' : ''}>
              <span>Our history</span>
            </NavLink>
            <NavLink to="/aboutus/leadershipteam" className={location.pathname === '/aboutus/leadershipteam' ? 'active' : ''}>
              <span>Leadership team</span>
            </NavLink>
            <NavLink to="/aboutus/newsthrought" className={location.pathname === '/aboutus/newsthrought' ? 'active' : ''}>
              <span>News and thought leadership</span>
            </NavLink>
            <NavLink to="/aboutus/ouroffices" className={location.pathname === '/aboutus/ouroffices' ? 'active' : ''}>
              <span>Our offices</span>
            </NavLink>
            <NavLink to="/golf" className={location.pathname === '/golf' ? 'active' : ''}>
              <span>Sentry and golf</span>
            </NavLink>
            <NavLink to="/aboutus/thesentry" className={location.pathname === '/aboutus/thesentry' ? 'active' : ''}>
              <span>The Sentry</span>
            </NavLink>
          </Nav>
        </div>
      </div>
    </>
  )
}

export default Sidebar